import { useQuery } from '@tanstack/react-query';

import { getReports } from '../api/reports.api';
import { REPORTS_QUERY_KEY } from '../constants/reports-query-keys';

export const useReports = () => {
  return useQuery({
    queryKey: REPORTS_QUERY_KEY,
    queryFn: getReports,
    staleTime: 5 * 60 * 1000,
  });
};
